import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04f2dd20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-terminal-solutions-wrap" }
const _hoisted_2 = { class: "tab-terminal-solutions" }
const _hoisted_3 = { class: "tab-terminal-solutions-title" }
const _hoisted_4 = { class: "tab-terminal-solutions-tabs row" }
const _hoisted_5 = { class: "tab-terminal-solutions-button-wrap" }

import {
  app_andpoid_for_pos,
  cash_in_cash_out,
  creditomat_terminal,
  cryptomat_terminal,
  edc,
  pos_terminals,
  UiButton,
  HelpModel,
  useLocalizationStore,
} from "@/shared";
import {BlockItemTab} from "@/entities";
import {onBeforeMount, ref} from "vue";
import {useRouter} from "vue-router";

const linkTerminal = "terminal-solution";


export default /*#__PURE__*/_defineComponent({
  __name: 'tab-terminal-solutions',
  setup(__props) {

const router = useRouter();
const {translate} = useLocalizationStore();

onBeforeMount(() => {
  initArrData();
});

const arrData = ref<Array<HelpModel>>(new Array<HelpModel>());

const initArrData = () => {
  arrData.value.push(new HelpModel({
    Text: "tab_terminal_solutions_second_text",
    Image: cash_in_cash_out,
    ScrollHash: "#cash"
  }));
  arrData.value.push(new HelpModel({
    Text: "tab_terminal_solutions_first_text",
    Image: pos_terminals,
    ScrollHash: "#pos"
  }));
  arrData.value.push(new HelpModel({
    Text: "tab_terminal_solutions_third_text",
    Image: cryptomat_terminal,
    ScrollHash: "#cryptomat"
  }));
  arrData.value.push(new HelpModel({
    Text: "tab_terminal_solutions_fifth_text",
    Image: creditomat_terminal,
    ScrollHash: "#creditomat"
  }));
  arrData.value.push(new HelpModel({
    Text: "tab_terminal_solutions_fourth_text",
    Image: edc,
    ScrollHash: "#selfservice"
  }));
  arrData.value.push(new HelpModel({
    Text: "tab_terminal_solutions_sixth_text",
    Image: app_andpoid_for_pos,
    ScrollHash: "#androidapp"
  }));
};
const onClick = () => {
  router.push({name: "terminal-solution"});
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(translate)("tab_terminal_solutions_title")), 1),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(arrData.value, (item, ind) => {
          return (_openBlock(), _createBlock(_unref(BlockItemTab), {
            key: ind,
            image: item.Image,
            text: _unref(translate)(item.Text),
            link: linkTerminal,
            "scroll-hash": item.ScrollHash,
            class: "col-6"
          }, null, 8, ["image", "text", "scroll-hash"]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(UiButton), {
          class: "tab-terminal-solutions-button",
          color: "#71B92F",
          height: "45",
          onClick: onClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(translate)("view_terminal_solutions")), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})